<script setup lang="ts">
import type { ListboxGroupProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ListboxGroup, ListboxGroupLabel, useId } from 'reka-ui';
import { computed, onMounted, onUnmounted } from 'vue';
import { cn } from '@/lib/utils';
import { provideCommandGroupContext, useCommand } from '.';

const props = defineProps<
    ListboxGroupProps & {
        class?: HTMLAttributes['class'];
        heading?: string;
    }
>();

const delegatedProps = reactiveOmit(props, 'class');

const { allGroups, filterState } = useCommand();
const id = useId();

const isRender = computed(() => (!filterState.search ? true : filterState.filtered.groups.has(id)));

provideCommandGroupContext({ id });
onMounted(() => {
    if (!allGroups.value.has(id)) allGroups.value.set(id, new Set());
});
onUnmounted(() => {
    allGroups.value.delete(id);
});
</script>

<template>
    <ListboxGroup
        v-bind="delegatedProps"
        :id="id"
        :class="
            cn(
                'text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium',
                props.class,
            )
        "
        :hidden="isRender ? undefined : true"
    >
        <ListboxGroupLabel
            v-if="heading"
            :class="
                cn(
                    'text-muted-foreground px-2 py-1.5 text-xs font-medium',
                    'text-md px-4 pt-8 pb-1 text-gray-300', // atNorth overrides
                )
            "
        >
            {{ heading }}
        </ListboxGroupLabel>
        <slot />
    </ListboxGroup>
</template>
